import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';

import { RequestPageParams } from '@shared/models';
import { MocketBankService } from '@shared/services';
import { fromAuth } from '@shared/store';
import { MocketBankAccountActions } from '@shared/store/mocketbnk-store/mocketbank-account.actions';

@Injectable()
export class MocketBankAccountEffects {
  constructor(
    private actions$: Actions,
    private mocketBankService: MocketBankService,
    private store: Store,
  ) {}

  getMocketBankAccounts$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(MocketBankAccountActions.loadMocketBankAccounts),
      concatLatestFrom(() => this.store.select(fromAuth.selectBusinessAccountId)),
      mergeMap(([payload, activeBusinessAccountId]: [payload: { params: RequestPageParams }, activeBusinessAccountId: string | null]) => {
        return this.mocketBankService.getMocketBankAccounts(activeBusinessAccountId!, payload.params).pipe(
          map((response) =>
            MocketBankAccountActions.loadMocketBankAccountSuccess({
              mocketBankAccounts: response.items,
              totalElements: response.totalElements,
            }),
          ),
          catchError((error) => {
            return of(MocketBankAccountActions.loadMocketBankAccountError({ error }));
          }),
        );
      }),
    );
  });
}
